import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
  setInModel,
} from '../../../utils/helpers/model.helper';
import { CompanyInfo } from './company-info.model';
import { CompanySettings } from './company-settings/company-settings.model';
import { DocumentPresetSettings } from './document-preset-settings/document-preset-settings.model';
import { PostPurchaseInfo } from './post-purchase-info.model';

export const SETTINGS_CONTENT_SCHEMA = Object.freeze({
  COMPANY_INFO: CompanyInfo,
  COMPANY_SETTINGS: CompanySettings,
  DOCUMENT_PRESET_SETTINGS: DocumentPresetSettings,
  POST_PURCHASE_INFO: PostPurchaseInfo,
});
const RECORD = generateSchema(SETTINGS_CONTENT_SCHEMA);
const KEYS: any = generateKeys(SETTINGS_CONTENT_SCHEMA);

export class SettingsContent extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));

    const selfModel = setInModel(this, [
      {
        key: KEYS.COMPANY_INFO,
        value: new CompanyInfo(this.companyInfo),
      },
      {
        key: KEYS.COMPANY_SETTINGS,
        value: new CompanySettings(this.companySettings),
      },
      {
        key: KEYS.DOCUMENT_PRESET_SETTINGS,
        value: new DocumentPresetSettings(this.documentPresetSettings),
      },
      {
        key: KEYS.POST_PURCHASE_INFO,
        value: new PostPurchaseInfo(this.postPurchaseInfo),
      },
    ]);

    return selfModel as SettingsContent;
  }

  get companyInfo(): CompanyInfo {
    return this.get(KEYS.COMPANY_INFO);
  }

  get companySettings(): CompanySettings {
    return this.get(KEYS.COMPANY_SETTINGS);
  }

  get documentPresetSettings(): DocumentPresetSettings {
    return this.get(KEYS.DOCUMENT_PRESET_SETTINGS);
  }

  get postPurchaseInfo(): PostPurchaseInfo {
    return this.get(KEYS.POST_PURCHASE_INFO);
  }
}
